import { ISearchHeaderInputProps } from '../interfaces/searchHeaderProps';
import { BaseObj } from '../types/baseObj';
import { PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_SIZE } from '../core/pagination';

export function getStateFromSearchInputProps<T extends BaseObj>(searchInputProps: ISearchHeaderInputProps[], pageNamespace?: string, sizeNamespace?: string): T {
  return (searchInputProps as any[]).reduce((acc: T, cur: ISearchHeaderInputProps) => {
    (acc as BaseObj)[cur.name] = '';
    return acc;
  }, {
    [pageNamespace || 'page']: PAGINATION_DEFAULT_PAGE,
    [sizeNamespace || 'size']: PAGINATION_DEFAULT_SIZE
  });
}